import { Controller } from "@hotwired/stimulus";
import {
  DragulaModule,
  FilterModule,
  ScrollModule,
  ToggleEmptyRolesModule,
  ObserverModule,
  DeleteMemberScaleModule,
  SharedModule,
  ToggleWeekModule,
} from "./kanban";

export default class KanbanController extends Controller {
  static targets = [
    "integrantesColumn",
    "escalasContainer",
    "kanbanBoard",
    "filtroIntegrantes",
    "scrollLeft",
    "scrollRight",
    "toggleEmptyFunctions",
    "eyeOpenIcon",
    "eyeClosedIcon",
    "deleteMemberScale",
    "toggleWeek",
  ];

  connect() {
    this.isDragging = false;

    // Inicializar módulos
    this.dragulaModule = new DragulaModule(this);
    this.filterModule = new FilterModule(this);
    this.scrollModule = new ScrollModule(this);
    this.toggleEmptyRolesModule = new ToggleEmptyRolesModule(this);
    this.observerModule = new ObserverModule(this);
    this.deleteMemberScaleModule = new DeleteMemberScaleModule(this);
    this.sharedModule = new SharedModule(this);
    this.toggleWeekModule = new ToggleWeekModule();
    // Inicializar todos os módulos
    this.initializeModules();
  }

  disconnect() {
    // Destruir módulos
    this.dragulaModule.destroy();
    this.observerModule.destroy();
  }

  initializeModules() {
    this.dragulaModule.initialize();
    this.filterModule.initialize();
    this.scrollModule.initialize();
    this.toggleEmptyRolesModule.initialize();
    this.observerModule.initialize();
    this.deleteMemberScaleModule.initialize();
    this.sharedModule.initialize();
    this.toggleWeekModule.initialize();
  }

  reinitialize() {
    // Destruir a instância atual do Dragula
    this.dragulaModule.destroy();

    // Reinicializar todas as funcionalidades com um atraso maior
    // para garantir que o DOM esteja completamente atualizado
    setTimeout(() => {
      // Verificar se o controlador ainda está conectado
      if (this.element) {
        this.initializeModules();
      }
    }, 500);
  }

  // Método para alternar a visibilidade da semana
  toggleWeek(event) {
    if (!event || !this.toggleWeekModule) return;

    try {
      this.toggleWeekModule.toggleWeek(event);
    } catch (error) {
      console.error("Erro ao alternar visibilidade da semana:", error);
    }
  }
}
